import type { SignDocument } from "../Models/Domain";

import useSignDocuments from "../Store";

import { sendDocumentToSign } from "@/Services/TherapyApi/Clients";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import SignDocumentTransformer from "@/Modules/Transformers/SignDocument";

async function SendDocumentsToSignActionHandler(
  uuid: string,
  clientUuid: string
): Promise<SignDocument | undefined> {
  const signDocumentsStore = useSignDocuments();

  signDocumentsStore.isLoading = true;

  const resp = await sendDocumentToSign(clientUuid, uuid);

  if (isApiError(resp)) {
    return undefined;
  }

  const doc = SignDocumentTransformer.toDomain(resp);

  signDocumentsStore.addDocument(doc);

  signDocumentsStore.isLoading = false;

  return doc;
}

export default SendDocumentsToSignActionHandler;
